export default {
  about: {
    ceo: {
      eyebrow: ' ',
      title: '代表メッセージ',
      heading: 'まずはお取引先様に常に喜んで頂けるように、そしてよりよい社会の発展に貢献出来るように',
      p1: '株式会社大真のホームページにアクセスいただき、誠にありがとうございます。\n当社は、日本の化学品・レアメタルを世界へ届ける専門商社として、輸出入および三国間貿易を展開しております。',
      p2: '人口減少が進む日本において、世界との接続はますます重要になっています。変化の激しい国際環境の中で、日本の技術力や品質を確かなビジネスへと結びつけることが、私たちの役割であると考えています。',
      p3: '当社は、異文化間の調整力、迅速な意思決定、ファイナンス機能、リスクマネジメントを強みに、単なる仲介ではなく「価値をつなぐ存在」であり続けることを目指しています。',
      closing: '取引先の皆様に信頼される企業であること。そして、社員一人ひとりが誇りを持って働ける組織であること。その積み重ねが、持続可能な社会への貢献につながると信じています。\n\n今後とも変わらぬご支援を賜りますよう、よろしくお願い申し上げます。',
      name: '代表取締役 大口 真豪',
    },
    profile: {
      eyebrow: '',
      title: '企業情報',
      items: [
        { label: '会社名', value: '株式会社大真　（英文: Daishin Corporation)' },
        { label: '設立年月日', value: '2004年6月15日' },
        { label: '資本金', value: '1億円' },
        { label: '売上高', value: '約10億円' },
        { label: '代表者', value: '代表取締役 大口 真豪' },
        { label: '事業内容', value: '化学品・金属等の輸出入及び国内販売、三国間貿易など' },
        { label: '所在地', value: '〒542-0081　大阪市中央区南船場3-8-7' },
      ],
    },
    history: {
      eyebrow: '',
      title: '沿革',
      items: [
        { date: '2004年6月', event: '工業薬品の輸出入及び国内販売を目的として兵庫県尼崎市に設立' },
        { date: '2024年9月', event: '毒物劇物一般販売業を取得', pdfLink: '/docs/poison_for_sale.pdf' },
        { date: '2024年10月', event: '毒物劇物輸入業 登録', pdfLink: '/docs/import_poison.pdf' },
        { date: '2024年12月', event: '麻薬等原料輸出業者業務登録証明書を取得', pdfLink: '/docs/raw_material_exports.pdf' },
        { date: '2024年12月', event: '麻薬等原料輸入業者業務登録証明書を取得', pdfLink: '/docs/import_edraw_materials.pdf' },
        { date: '2014年12月', event: '大阪市北区へ移転' },
        { date: '2023年6月', event: '大阪市中央区へ移転' },
      ],
    },
    access: {
      eyebrow: '',
      title: 'アクセス',
      addressTitle: '住所',
      address: '〒542-0081\n大阪市中央区南船場3-8-7',
      phone: 'TEL: 06-6371-3730',
      hoursTitle: '営業時間',
      hours: '月〜金：9:00〜18:00\n（土・日・祝日休業）',
      stationsTitle: '最寄駅',
      stations: [
        '大阪Metro 心斎橋駅 1番出口 徒歩4分',
        '大阪Metro 長堀橋駅 北7番出口 徒歩8分',
        '大阪Metro 本町駅 12番出口 徒歩10分',
      ],
    },
    mapTitle: '大真株式会社 オフィス所在地',
  },
};
